import {useContext} from "react";
import LocationListItem from "./LocationListItem";
import {MapContext} from "../context/MapContext";

const FeaturedMarkerGlobe = () => {
  const {featuredMarker} = useContext(MapContext)

  return featuredMarker !== null ? (
    <article className="featured-marker-globe">
      <LocationListItem className="no-featured-styles" item={featuredMarker}/>
    </article>
  ) : null

}

export default FeaturedMarkerGlobe;
